import CollectionView from 'picnic/core/views/Collection';
import Tag from 'app/cms/search/views/Tag';
import Backbone from 'backbone';


var
	SEARCH_LENGTH = 3
;


class View extends CollectionView {

	get childviewclass() {
		return Tag;
	}

	get target() {
		return this.$el.find('.form-row');
	}

	get insertMethod() {
		return 'insertAfter';
	}

	get collection() {
		this._collection = this._collection || new Backbone.Collection();
		return this._collection;
	}

	events() {
		return {
			'keyup :text': this._onKeyUp,
			'click .clear': this._onClear
		};
	}

	_onKeyUp(event) {
		var query = event.currentTarget.value;

		if (query && query.trim().length >= SEARCH_LENGTH) {
			this.collection.set(
				this.options.tags.filter(
					tag => (tag.get('name').toLowerCase().indexOf(query.toLowerCase()) >= 0)
				)
			);
		} else {
			this.collection.reset();
		}
	}

	_onClear(event) {
		event.preventDefault();

		this.$el.find(':text').val('');
		this.collection.reset();
	}

}

export default View;
